module.exports = __webpack_public_path__ + "img/TUR-i-1-I.f0923a4b.png";